import React, { useState, useRef, useEffect } from 'react';
import {
    Box,
    Typography,
    Button,
    Avatar,
    IconButton,
    Divider,
    Link
} from '@mui/material';
import VenueDetailView from '../../venue/VenueDetailView';
import ServiceSection from '../../bookings/ServiceSection';
import ComingSoonPopup from '../../common/ComingSoonPopup';
import axios from 'axios';
import { getBackendUserUrl } from '../../../utils/utils';
import ServiceDetailView from '../../bookings/ServiceDetailView';

const BookingsManager = ({ eventDetails, setEventDetails }) => {
    const [expandedServiceId, setExpandedServiceId] = useState(null);
    const [customRequestStatus, setCustomRequestStatus] = useState({});

    // const [selectedService, setSelectedService] = useState(null);
    const [venueRequest, setVenueRequest] = useState(null);
    const { showComingSoon } = ComingSoonPopup({
        message: "We're working on the messaging feature. Stay tuned!"
    });
    
    console.log("BookingsManager eventDetails", eventDetails);
    // Extract venue and event
    const venue = eventDetails.venue ? [{
        id: eventDetails.venue.id,
        name: eventDetails.venue.title,
        logo: eventDetails.venue.images?.[0]?.url,
        status: eventDetails.venue.status || 'accepted',
        ...eventDetails.venue
    }] : [];
    const eventData = eventDetails.event;

    // Fetch VenueRequest on mount
    useEffect(() => {
        const fetchVenueRequest = async () => {
            if (!eventData?.eventId) return;
            try {
                const res = await axios.get(`${getBackendUserUrl()}/event/venue_request?eventId=${eventData.eventId}`);
                if (res.data && res.data.venueRequest) {
                    setVenueRequest(res.data.venueRequest);
                } else {
                    setVenueRequest(null);
                }
            } catch (err) {
                setVenueRequest(null);
            }
        };
        fetchVenueRequest();
    }, [eventData?.eventId]);

    console.log("BookingsManager eventDetails", eventDetails);
    // Get all addons
    const addons = eventData?.addons || [];
    console.log("BookingsManager addons", addons);
    // Filter catering services
    // TODO review addonType vs companyType, as it should only have to handle addonType (but is only implemented from adding from this page, not from event creation)
    const catering = addons
        .filter(addon => (addon?.addonType?.toLowerCase() === 'catering' || addon?.industry?.toLowerCase() ==='catering' || addon?.companyType?.toLowerCase()?.includes('catering')))
        .map(addon => ({
 
            ...addon
        }));

    // Filter sponsors
    const sponsors = eventData?.sponsors || [];

    console.log("After sponsors", sponsors);
    // For vendors, show all addons that aren't sponsors or catering
    const vendors = addons
        .filter(addon => {
            const type = addon?.addonType?.toLowerCase() || addon?.industry?.toLowerCase();
            return type !== 'catering';
        })
        .map(addon => ({
            ...addon
        }));

    const handleManageClick = (service) => {
        if (!service) {
            setExpandedServiceId(null);
            return;
        }
        const id = service?.venueId || service.companyId;
        // If clicking the same service that's already expanded, collapse it
        if (expandedServiceId === id) {
            setExpandedServiceId(null);
        } else {
            setExpandedServiceId(id);
        }
    };

    const handleMessageClick = (service) => {
        showComingSoon();
    };

    const handleRemoveClick = (service) => {
        // Implement remove functionality
        console.log('Remove clicked for service:', service);
    };

    const handleServiceAdded = async (service) => {
        console.log("BookingsManager handleServiceAdded service", service);
        
        try {
            // Format the service data for the API
            const addonData = {
                companyId: service.companyId,
                addonType: service.addonType || service.type || "vendor",
                status: "pending",
                lastSeenStatus: "pending",
                selected: true,
                price: service.price || 0,
                packageId: service.packageId || null,
                includes: service.includes || null,
                actualhours: service.actualhours || null,
                addonitems: service.addonitems || [],
                discount: service.discount || null
            };

            console.log("Sending addon data:", addonData);

            // Make API call to add the vendor
            const response = await axios.post(`${getBackendUserUrl()}/event/add_vendor_for_event/${eventData.eventId}`, addonData);

            console.log("Vendor added successfully:", response.data);

            // Update local state based on service type
            const type = (service.addonType || service.type || "").toLowerCase();
            if (type.includes("sponsor")) {
                setEventDetails(prev => ({
                    ...prev,
                    event: {
                        ...prev.event,
                        sponsors: [...(prev.event.sponsors || []), service]
                    }
                }));
            } else {
                setEventDetails(prev => ({
                    ...prev,
                    event: {
                        ...prev.event,
                        addons: [...(prev.event.addons || []), service]
                    }
                }));
            }
            
            console.log("BookingsManager eventDetails updated");
            
        } catch (error) {
            console.error("Error adding service:", error);
            if (error.response) {
                console.error("API Error:", error.response.data);
            }
            // You might want to show an error message to the user here
        }
    };

    const handleRemoveService = async (service) => {
        try {
            const companyId = service.companyId || service.id;
            
            const response = await axios.delete(`${getBackendUserUrl()}/event/remove_vendor_for_event/${eventData.eventId}/${companyId}`);
            console.log("Vendor added successfully:", response.data);

            setEventDetails(prev => {
                return {
                    ...prev,
                    event: {
                        ...prev.event,
                        sponsors: (prev.event.sponsors || []).filter(a => a.companyId !== companyId),
                        addons: (prev.event.addons || []).filter(a => a.companyId !== companyId)
                    }
                    };
                });
            setExpandedServiceId(null);
        } catch (error) {
            console.error("Error removing service:", error);
            if (error.response) {
                console.error("API Error:", error.response.data);
            }
        }
    };

    const handleUpdateService = (updatedAddon) => {
        setEventDetails(prev => ({
            ...prev,
            event: {
                ...prev.event,
                addons: prev.event.addons.map(a =>
                    a.eventAddonsId === updatedAddon.eventAddonsId ? updatedAddon : a
                )
            }
        }));
    };

    // Helper: get all selected packages for a company
    const getSelectedPackagesForCompany = (companyId) => {
        const allAddons = [...(eventData?.addons || []), ...(eventData?.sponsors || [])];
        return allAddons.filter(a => a.companyId === companyId && a.packageId);
    };

    // Handler: select a package for a company (can select multiple)
    const handleRequestPackage = (pkg) => {
        // Add the selected package as an addon (or sponsor if type includes sponsor)
        const newAddon = {
            ...pkg,
            companyId: pkg.companyId || pkg.company_id || pkg.company_id,
            packageId: pkg.packageId,
            name: pkg.name,
            price: pkg.price,
            addonType: pkg.type || 'service',
            status: 'pending',
            selected: true
        };
        setEventDetails(prev => {
            // Determine if sponsor or addon
            const isSponsor = (pkg.type || '').toLowerCase().includes('sponsor');
            if (isSponsor) {
                return {
                    ...prev,
                    event: {
                        ...prev.event,
                        sponsors: [...(prev.event.sponsors || []), newAddon]
                    }
                };
            } else {
                return {
                    ...prev,
                    event: {
                        ...prev.event,
                        addons: [...(prev.event.addons || []), newAddon]
                    }
                };
            }
        });
    };

    // Handler: request a custom package
    const handleRequestCustomPackage = async (customPkg) => {
        // Add the custom package as an addon (or sponsor if type includes sponsor)
        const newAddon = {
            ...customPkg,
            companyId: customPkg.companyId,
            name: customPkg.name,
            custom: true,
            status: 'pending',
            selected: true
        };
        setEventDetails(prev => {
            // Determine if sponsor or addon
            const isSponsor = (customPkg.type || '').toLowerCase().includes('sponsor');
            if (isSponsor) {
                return {
                    ...prev,
                    event: {
                        ...prev.event,
                        sponsors: [...(prev.event.sponsors || []), newAddon]
                    }
                };
            } else {
                return {
                    ...prev,
                    event: {
                        ...prev.event,
                        addons: [...(prev.event.addons || []), newAddon]
                    }
                };
            }
        });
        // Show request sent status for this company
        setCustomRequestStatus(prev => ({ ...prev, [customPkg.companyId]: 'sent' }));
    };

    const renderExpandedContent = (service) => {
        console.log("Render expanded content service", service);
        if (service.venueId) {
            return (
                <VenueDetailView
                    venue={service}
                    event={eventData}
                    venueRequest={venueRequest}
                    setVenueRequest={setVenueRequest}
                    onMinimize={() => handleManageClick(null)}
                />
            );
        }
        // For catering, sponsors, other services
        return (
            <ServiceDetailView
                service={service}
                // serviceType={}
                selectedPackages={getSelectedPackagesForCompany(service.companyId || service.id)}
                onRequestPackage={handleRequestPackage}
                onRequestCustomPackage={handleRequestCustomPackage}
                onRemove={handleRemoveService}
                customRequestStatus={customRequestStatus[service.companyId || service.id]}
                onMinimize={() => handleManageClick(null)}
            />
        );
    };

    return (
        <Box paddingLeft={4} paddingRight={4} paddingBottom={6}>
            <Box sx={{ mt: 4 }}>
                <ServiceSection 
                    sectionTitle="VENUE" 
                    services={venue} 
                    eventData={eventData}
                    venueRequest={venueRequest}
                    setVenueRequest={setVenueRequest}
                    onManageClick={handleManageClick}
                    expandedServiceId={expandedServiceId}
                    onMessageClick={handleMessageClick}
                    onRemoveClick={handleRemoveClick}
                    renderExpandedContent={renderExpandedContent}
                    onServiceSelected={handleServiceAdded}
                />
                <ServiceSection 
                    sectionTitle="CATERING" 
                    services={catering} 
                    eventData={eventData}
                    venueRequest={venueRequest}
                    setVenueRequest={setVenueRequest}
                    onManageClick={handleManageClick}
                    expandedServiceId={expandedServiceId}
                    onMessageClick={handleMessageClick}
                    onRemoveClick={handleRemoveClick}
                    renderExpandedContent={renderExpandedContent}
                    onServiceSelected={handleServiceAdded}
                />
                <ServiceSection 
                    sectionTitle="SPONSORS" 
                    services={sponsors} 
                    eventData={eventData}
                    venueRequest={venueRequest}
                    setVenueRequest={setVenueRequest}
                    onManageClick={handleManageClick}
                    expandedServiceId={expandedServiceId}
                    onMessageClick={handleMessageClick}
                    onRemoveClick={handleRemoveClick}
                    renderExpandedContent={renderExpandedContent}
                    onServiceSelected={handleServiceAdded}
                />
                <ServiceSection 
                    sectionTitle="Other Services" 
                    services={vendors} 
                    eventData={eventData}
                    venueRequest={venueRequest}
                    setVenueRequest={setVenueRequest}
                    onManageClick={handleManageClick}
                    expandedServiceId={expandedServiceId}
                    onMessageClick={handleMessageClick}
                    onRemoveClick={handleRemoveClick}
                    renderExpandedContent={renderExpandedContent}
                    onServiceSelected={handleServiceAdded}
                />
            </Box>
            {/* <CostBreakdown eventDetails={eventDetails} /> */}
        </Box>
    );
};

export default BookingsManager; 